import { render } from "./Produce.vue?vue&type=template&id=3a0431fc"
import script from "./Produce.vue?vue&type=script&lang=js"
export * from "./Produce.vue?vue&type=script&lang=js"
script.render = render

export default script